import { analyticEvent, overlayEvent } from './common';

export const unsubscribeFromPostalMail = analyticEvent('my preference center: unsubscribe from postal mail button');

const confirmText = 'confirm your mailing address';
export const confirmAddressOverlay = overlayEvent(confirmText);

export const confirmMailingEvent = analyticEvent('confirm your mailing address: confirm');
export const unverifiedMailingEvent = analyticEvent('confirm your mailing address: use unverified');

export const confirmPostalUnsub = analyticEvent('mktg pref:mail list>n');
